export default "__VITE_ASSET__d85e3ac5__"